import { createSlice } from '@reduxjs/toolkit';
import { message as toaster } from 'antd';
import { API } from 'api';

const URL = process.env.REACT_APP_DYNAMIC_QR_URL_OLD;
const initialState = {};

export const collectionSlice = createSlice({
	name: 'collection',
	initialState,
	reducers: {},
});

export const getGenerateQR =
	({ store_id, user_id, amount }) =>
	async () => {
		const CREDENTIALS = {
			method: 'post',
			url: `${URL}/generateQR`,
			data: {
				user_id,
				store_id,
				amount: `${String(amount?.toFixed(2))}`,
			},
		};

		return API.common(CREDENTIALS).then((response) => response.data);
	};

export const triggerFailUPI =
	({ store_id, user_id, amount, reason = 'TimedOut' }) =>
	async () => {
		const CREDENTIALS = {
			method: 'post',
			url: `${URL}/fail-upi`,
			data: {
				user_id,
				storeId: store_id,
				amount: `${String(amount?.toFixed(2))}`,
				reason,
			},
		};

		return API.common(CREDENTIALS).then((response) => {
			toaster.success(response?.data?.Msg);

			return response.data;
		});
	};

export const checkUTRReference =
	({ query, amount, salesman_id, store_id }) =>
	async () => {
		const CREDENTIALS = {
			method: 'post',
			url: `${URL}/check-utr`,
			data: {
				query,
				amount: `${String(Number(amount)?.toFixed(2))}`,
				user_id: salesman_id,
				storeId: store_id,
			},
		};

		return API.common(CREDENTIALS).then((response) => {
			if (response?.data?.length === 0) {
				toaster.error('No UPI data found');
			}

			return response.data;
		});
	};

export default collectionSlice.reducer;
